import usePrevious from './usePrevious';

/**
 * https://stackoverflow.com/a/56817365
 * 
 * @param {*} val 
 * @returns 
 */
function useHasChanged(val) {
	const prevVal = usePrevious(val);

	return prevVal !== val;
}

export default useHasChanged;
